import { Routes } from '@all-hands-hq/plex-graphql-schema';
import { createStyles, Link, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import GoogleButton from 'react-google-button';
import { useHistory } from 'react-router-dom';

import { ReactComponent as LoggedOutArtSvg } from '../../assets/logged_out_art.svg';
import { colorPalette, TextSizesEnum } from '../../theme';
import { PlexTypography } from '../shared/primitives/PlexTypography';

const LoggedOutPageContainer = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.backgroundContainer}>
        <div className={classes.backgroundTop} />
        <div className={classes.backgroundMid} />
        <div className={classes.backgroundBottom} />
      </div>
      <div className={classes.artContainer}>
        <div>
          <LoggedOutArtSvg />
        </div>
        <div className={classes.bottomContainer}>{children}</div>
      </div>
    </div>
  );
};

export const LoggedOutPage = (): React.ReactElement => {
  const classes = useStyles();
  const history = useHistory();
  const params = new URLSearchParams();
  params.append('redirect', `${history.location.pathname}${history.location.search}`);

  return (
    <LoggedOutPageContainer>
      <PlexTypography
        className={classes.message}
        text={'You have been successfully logged out'}
        size={TextSizesEnum.XLarge}
      />
      <GoogleButton
        className={classes.googleLoginButton}
        onClick={(): unknown => (window.location.href = `${Routes.LOGIN_API_PATH}?${params.toString()}`)}
        type="light"
      />
      <div className={classes.homeButton}>
        <Link href={Routes.HOME_PATH} underline={'always'}>
          or Back Home
        </Link>
      </div>
    </LoggedOutPageContainer>
  );
};

export const PersonalGmailPage = (): React.ReactElement => {
  const classes = useStyles();
  return (
    <LoggedOutPageContainer>
      <PlexTypography
        className={classes.message}
        text={'Thanks for your interest in Plex. Our app currently only works with GSuite accounts.'}
        size={TextSizesEnum.XLarge}
      />
      <PlexTypography
        className={classes.message}
        text={'Please click the button below to log in with an eligible account.'}
        size={TextSizesEnum.XLarge}
      />
      <GoogleButton
        className={classes.googleLoginButton}
        onClick={(): unknown => (window.location.href = Routes.LOGIN_API_PATH)}
        type="light"
      />
    </LoggedOutPageContainer>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      overflowY: 'hidden',
      overflowX: 'auto',
      height: '100vh',
      width: '100%',
      paddingTop: 80,
      position: 'relative',
    },
    artContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 48,
      paddingRight: 48,
      overflowY: 'auto',
      zIndex: 1, // to go over the white background
    },
    bottomContainer: {
      display: 'flex',
      marginTop: 56,
      flexDirection: 'column',
      justifyContent: 'center',
    },
    message: {
      fontWeight: 'bold',
      color: '#464663',
      textAlign: 'center',
      alignSelf: 'center',
    },
    homeButton: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 24,
    },
    backgroundContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    backgroundTop: {
      height: '100%',
      width: '100%',
      backgroundColor: '#fff',
    },
    backgroundMid: {
      height: 100,
      width: '100%',
      backgroundImage: `linear-gradient(to bottom left, #FFF 50%, ${colorPalette.general.backgroundGray} 50%)`,
    },
    backgroundBottom: {
      height: '100%',
      width: '100%',
      backgroundColor: colorPalette.general.backgroundGray,
    },
    googleLoginButton: {
      marginTop: 20,
      alignSelf: 'center',
    },
  })
);
